var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withForwardedRef } from '../utils/helpers/reactHelpers';
const variants = {};
variants.h1 = styled.h1 `
  font-size: ${(p) => p.theme.SizeFontTypographyH1};
  line-height: ${(p) => p.theme.SizeLineHeightTypographyH1};
  font-weight: ${(p) => p.theme.ContentFontWeightTypographyH1};
`;
variants.h2 = styled.h2 `
  font-size: ${(p) => p.theme.SizeFontTypographyH2};
  line-height: ${(p) => p.theme.SizeLineHeightTypographyH2};
  font-weight: ${(p) => p.theme.ContentFontWeightTypographyH2};
`;
variants.h3 = styled.h3 `
  font-size: ${(p) => p.theme.SizeFontTypographyH3};
  line-height: ${(p) => p.theme.SizeLineHeightTypographyH3};
  font-weight: ${(p) => p.theme.ContentFontWeightTypographyH3};
`;
variants.h4 = styled.h4 `
  font-size: ${(p) => p.theme.SizeFontTypographyH4};
  line-height: ${(p) => p.theme.SizeLineHeightTypographyH4};
  font-weight: ${(p) => p.theme.ContentFontWeightTypographyH4};
`;
variants.h5 = styled.h5 `
  font-size: ${(p) => p.theme.SizeFontTypographyH5};
  line-height: ${(p) => p.theme.SizeLineHeightTypographyH5};
  font-weight: ${(p) => p.theme.ContentFontWeightTypographyH5};
`;
variants.h6 = styled.h6 `
  font-size: ${(p) => p.theme.SizeFontTypographyH6};
  line-height: ${(p) => p.theme.SizeLineHeightTypographyH6};
  font-weight: ${(p) => p.theme.ContentFontWeightTypographyH6};
`;
variants.subhead1 = styled.h6 `
  font-size: ${(p) => p.theme.SizeFontTypographySubhead1};
  line-height: ${(p) => p.theme.SizeLineHeightTypographySubhead1};
  font-weight: ${(p) => p.theme.ContentFontWeightTypographySubhead1};
`;
variants.subhead2 = styled.h6 `
  font-size: ${(p) => p.theme.SizeFontTypographySubhead2};
  line-height: ${(p) => p.theme.SizeLineHeightTypographySubhead2};
  font-weight: ${(p) => p.theme.ContentFontWeightTypographySubhead2};
`;
variants.body1 = styled.p `
  font-size: ${(p) => p.theme.SizeFontTypographyBody1};
  line-height: ${(p) => p.theme.SizeLineHeightTypographyBody1};
`;
variants.body2 = styled.p `
  font-size: ${(p) => p.theme.SizeFontTypographyBody2};
  line-height: ${(p) => p.theme.SizeLineHeightTypographyBody2};
`;
variants.body3 = styled.p `
  font-size: ${(p) => p.theme.SizeFontTypographyBody3};
  line-height: ${(p) => p.theme.SizeLineHeightTypographyBody3};
`;
variants.body4 = styled.p `
  font-size: ${(p) => p.theme.SizeFontTypographyBody4};
  line-height: ${(p) => p.theme.SizeLineHeightTypographyBody4};
`;
variants.price1 = styled.span `
  font-size: ${(p) => p.theme.SizeFontTypographyPrice1};
  line-height: ${(p) => p.theme.SizeLineHeightTypographyPrice1};
  font-weight: ${(p) => p.theme.ContentFontWeightTypographyPrice1};
`;
variants.price2 = styled.span `
  font-size: ${(p) => p.theme.SizeFontTypographyPrice2};
  line-height: ${(p) => p.theme.SizeLineHeightTypographyPrice2};
  font-weight: ${(p) => p.theme.ContentFontWeightTypographyPrice2};
`;
variants.price3 = styled.span `
  font-size: ${(p) => p.theme.SizeFontTypographyPrice3};
  line-height: ${(p) => p.theme.SizeLineHeightTypographyPrice3};
  font-weight: ${(p) => p.theme.ContentFontWeightTypographyPrice3};
`;
variants.price4 = styled.span `
  font-size: ${(p) => p.theme.SizeFontTypographyPrice4};
  line-height: ${(p) => p.theme.SizeLineHeightTypographyPrice4};
  font-weight: ${(p) => p.theme.ContentFontWeightTypographyPrice4};
`;
variants.price5 = styled.span `
  font-size: ${(p) => p.theme.SizeFontTypographyPrice5};
  line-height: ${(p) => p.theme.SizeLineHeightTypographyPrice5};
`;
variants.titleXxl = styled.h1 `
  font-size: ${(p) => p.theme.SizeFontTypographyTitleXxl};
  line-height: ${(p) => p.theme.SizeLineHeightTypographyTitleXxl};
  font-weight: ${(p) => p.theme.ContentFontWeightTypographyTitleXxl};
`;
variants.titleXl = styled.h2 `
  font-size: ${(p) => p.theme.SizeFontTypographyTitleXl};
  line-height: ${(p) => p.theme.SizeLineHeightTypographyTitleXl};
  font-weight: ${(p) => p.theme.ContentFontWeightTypographyTitleXl};
`;
variants.titleL = styled.h3 `
  font-size: ${(p) => p.theme.SizeFontTypographyTitleL};
  line-height: ${(p) => p.theme.SizeLineHeightTypographyTitleL};
  font-weight: ${(p) => p.theme.ContentFontWeightTypographyTitleL};
`;
variants.titleM = styled.h4 `
  font-size: ${(p) => p.theme.SizeFontTypographyTitleM};
  line-height: ${(p) => p.theme.SizeLineHeightTypographyTitleM};
  font-weight: ${(p) => p.theme.ContentFontWeightTypographyTitleM};
`;
variants.titleS = styled.h5 `
  font-size: ${(p) => p.theme.SizeFontTypographyTitleS};
  line-height: ${(p) => p.theme.SizeLineHeightTypographyTitleS};
  font-weight: ${(p) => p.theme.ContentFontWeightTypographyTitleS};
`;
variants.titleXs = styled.h6 `
  font-size: ${(p) => p.theme.SizeFontTypographyTitleXs};
  line-height: ${(p) => p.theme.SizeLineHeightTypographyTitleXs};
  font-weight: ${(p) => p.theme.ContentFontWeightTypographyTitleXs};
`;
variants.bodyLBold = styled.span `
  font-size: ${(p) => p.theme.SizeFontTypographyBodyLBold};
  line-height: ${(p) => p.theme.SizeLineHeightTypographyBodyLBold};
  font-weight: ${(p) => p.theme.ContentFontWeightTypographyBodyLBold};
`;
variants.bodyLRegular = styled.span `
  font-size: ${(p) => p.theme.SizeFontTypographyBodyLRegular};
  line-height: ${(p) => p.theme.SizeLineHeightTypographyBodyLRegular};
  font-weight: ${(p) => p.theme.ContentFontWeightTypographyBodyLRegular};
`;
variants.bodyMBold = styled.span `
  font-size: ${(p) => p.theme.SizeFontTypographyBodyMBold};
  line-height: ${(p) => p.theme.SizeLineHeightTypographyBodyMBold};
  font-weight: ${(p) => p.theme.ContentFontWeightTypographyBodyMBold};
`;
variants.bodyM = styled.span `
  font-size: ${(p) => p.theme.SizeFontTypographyBodyM};
  line-height: ${(p) => p.theme.SizeLineHeightTypographyBodyM};
  font-weight: ${(p) => p.theme.ContentFontWeightTypographyBodyM};
`;
variants.bodySBold = styled.span `
  font-size: ${(p) => p.theme.SizeFontTypographyBodySBold};
  line-height: ${(p) => p.theme.SizeLineHeightTypographyBodySBold};
  font-weight: ${(p) => p.theme.ContentFontWeightTypographyBodySBold};
`;
variants.bodyS = styled.span `
  font-size: ${(p) => p.theme.SizeFontTypographyBodyS};
  line-height: ${(p) => p.theme.SizeLineHeightTypographyBodyS};
  font-weight: ${(p) => p.theme.ContentFontWeightTypographyBodyS};
`;
variants.caption1Bold = styled.span `
  font-size: ${(p) => p.theme.SizeFontTypographyCaption1Bold};
  line-height: ${(p) => p.theme.SizeLineHeightTypographyCaption1Bold};
  font-weight: ${(p) => p.theme.ContentFontWeightTypographyCaption1Bold};
`;
variants.caption1Regular = styled.span `
  font-size: ${(p) => p.theme.SizeFontTypographyCaption1Regular};
  line-height: ${(p) => p.theme.SizeLineHeightTypographyCaption1Regular};
  font-weight: ${(p) => p.theme.ContentFontWeightTypographyCaption1Regular};
`;
variants.caption2Bold = styled.span `
  font-size: ${(p) => p.theme.SizeFontTypographyCaption2Bold};
  line-height: ${(p) => p.theme.SizeLineHeightTypographyCaption2Bold};
  font-weight: ${(p) => p.theme.ContentFontWeightTypographyCaption2Bold};
`;
variants.caption2Regular = styled.span `
  font-size: ${(p) => p.theme.SizeFontTypographyCaption2Regular};
  line-height: ${(p) => p.theme.SizeLineHeightTypographyCaption2Regular};
  font-weight: ${(p) => p.theme.ContentFontWeightTypographyCaption2Regular};
`;
variants.priceXl = styled.span `
  font-size: ${(p) => p.theme.SizeFontTypographyPriceXl};
  line-height: ${(p) => p.theme.SizeLineHeightTypographyPriceXl};
  font-weight: ${(p) => p.theme.ContentFontWeightTypographyPriceXl};
`;
variants.priceXlStrikethrough = styled.span `
  font-size: ${(p) => p.theme.SizeFontTypographyPriceXl};
  line-height: ${(p) => p.theme.SizeLineHeightTypographyPriceXl};
  text-decoration: line-through;
`;
variants.priceL = styled.span `
  font-size: ${(p) => p.theme.SizeFontTypographyPriceL};
  line-height: ${(p) => p.theme.SizeLineHeightTypographyPriceL};
  font-weight: ${(p) => p.theme.ContentFontWeightTypographyPriceL};
`;
variants.priceLStrikethrough = styled.span `
  font-size: ${(p) => p.theme.SizeFontTypographyPriceL};
  line-height: ${(p) => p.theme.SizeLineHeightTypographyPriceL};
  text-decoration: line-through;
`;
variants.priceM = styled.span `
  font-size: ${(p) => p.theme.SizeFontTypographyPriceM};
  line-height: ${(p) => p.theme.SizeLineHeightTypographyPriceM};
  font-weight: ${(p) => p.theme.ContentFontWeightTypographyPriceM};
`;
variants.priceMStrikethrough = styled.span `
  font-size: ${(p) => p.theme.SizeFontTypographyPriceM};
  line-height: ${(p) => p.theme.SizeLineHeightTypographyPriceM};
  text-decoration: line-through;
`;
variants.priceS = styled.span `
  font-size: ${(p) => p.theme.SizeFontTypographyPriceS};
  line-height: ${(p) => p.theme.SizeLineHeightTypographyPriceS};
  font-weight: ${(p) => p.theme.ContentFontWeightTypographyPriceS};
`;
variants.priceSStrikethrough = styled.span `
  font-size: ${(p) => p.theme.SizeFontTypographyPriceS};
  line-height: ${(p) => p.theme.SizeLineHeightTypographyPriceS};
  text-decoration: line-through;
`;
variants.priceXs = styled.span `
  font-size: ${(p) => p.theme.SizeFontTypographyPriceXs};
  line-height: ${(p) => p.theme.SizeLineHeightTypographyPriceXs};
  font-weight: ${(p) => p.theme.ContentFontWeightTypographyPriceXs};
`;
variants.priceXsStrikethrough = styled.span `
  font-size: ${(p) => p.theme.SizeFontTypographyPriceXs};
  line-height: ${(p) => p.theme.SizeLineHeightTypographyPriceXs};
  text-decoration: line-through;
`;
variants.priceXxs = styled.span `
  font-size: ${(p) => p.theme.SizeFontTypographyPriceXxs};
  line-height: ${(p) => p.theme.SizeLineHeightTypographyPriceXxs};
  font-weight: ${(p) => p.theme.ContentFontWeightTypographyPriceXxs};
`;
variants.priceXxsStrikethrough = styled.span `
  font-size: ${(p) => p.theme.SizeFontTypographyPriceXxs};
  line-height: ${(p) => p.theme.SizeLineHeightTypographyPriceXxs};
  text-decoration: line-through;
`;
const TypographySC = styled.div `
  margin: 0;
  display: ${(p) => p.display || ''};
  font-family: ${(p) => p.theme.FontFamilyBase};
  color: ${(p) => p.mode === 'dark'
    ? p.theme.ColorFontTypographyModeDark
    : p.theme.ColorFontTypographyBase};
`;
const Typography = (props) => {
    const { variant, as: asProp, children, forwardedRef, mode } = props, rest = __rest(props, ["variant", "as", "children", "forwardedRef", "mode"]);
    return (React.createElement(TypographySC, Object.assign({ as: variants[variant], forwardedAs: asProp, ref: forwardedRef, mode: mode }, rest), children));
};
Typography.propTypes = {
    variant: PropTypes.oneOf([
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'subhead1',
        'subhead2',
        'body1',
        'body2',
        'body3',
        'body4',
        'price1',
        'price2',
        'price3',
        'price4',
        'price5',
        'titleXxl',
        'titleXl',
        'titleL',
        'titleM',
        'titleS',
        'titleXs',
        'bodyLBold',
        'bodyLRegular',
        'bodyMBold',
        'bodyM',
        'bodySBold',
        'bodyS',
        'caption1Bold',
        'caption1Regular',
        'caption2Bold',
        'caption2Regular',
        'priceXl',
        'priceXlStrikethrough',
        'priceL',
        'priceLStrikethrough',
        'priceM',
        'priceMStrikethrough',
        'priceS',
        'priceSStrikethrough',
        'priceXs',
        'priceXsStrikethrough',
        'priceXxs',
        'priceXxsStrikethrough'
    ]),
    as: PropTypes.oneOfType([PropTypes.elementType, PropTypes.string]),
    display: PropTypes.oneOf(['inline', 'block', 'inline-block']),
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    forwardedRef: PropTypes.any,
    mode: PropTypes.oneOf(['dark', 'light']),
    className: PropTypes.string
};
Typography.defaultProps = {
    as: null,
    display: undefined,
    variant: 'body2',
    children: null,
    forwardedRef: null,
    mode: 'light',
    className: undefined
};
export { Typography as TypographyRootComp };
export default withForwardedRef(Typography);
//# sourceMappingURL=Typography.js.map